import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 11/12;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 12 11" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.584 4.307L5.662 2.745l.622-.622a.5.5 0 000-.707L5.577.709a.5.5 0 00-.708 0L.863 4.716a.5.5 0 000 .707l.707.707a.5.5 0 00.707 0l.622-.622L4.46 7.431c-.383 1.047-.339 2.194.409 2.942a.5.5 0 00.707 0L7.58 8.369l2.272 2.243c.018.019.04.033.065.04l1.06.354c.13.044.255-.08.212-.21l-.354-1.061a.167.167 0 00-.04-.065L8.523 7.426l2.003-2.003a.5.5 0 000-.707c-.754-.754-1.906-.787-2.942-.41z" fill={color} fillRule="nonzero"/>
    </svg>
)

export default class IconPin extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
